import React from "react";
import { withRouter } from "react-router";
import Banner from "../../components/common/banner";
import Footer from "../../components/common/footer";
import FaqCard from "../../components/common/faqCard";
import styles from "./supportPage.module.scss";

const AppFaqPage = (props) => {
  // const { location, history } = props;

  const imageUrl =
    "https://firebasestorage.googleapis.com/v0/b/noosaapp.appspot.com/o/assets%2Fbanner_image_form.png?alt=media";

  const faqStyles = { textAlign: "center" };

  return (
    <div className={styles.supportContainer}>
      <Banner heading="WTD Noosa" subHeading="Support" imageUrl={imageUrl} />
      <div className={styles.supportBody}>
        <FaqCard
          containerAlign={faqStyles}
          question="Contact directly the app support."
        >
          <li style={faqStyles}>
            <a href="mailto: exempli.gratia.webdesign@gmail.com">
              exempli.gratia.webdesign@gmail.com
            </a>
          </li>
        </FaqCard>
      </div>
      <Footer />
    </div>
  );
};

export default withRouter(AppFaqPage);
